import { render, staticRenderFns } from "./affiliate-self-assessment.view.vue?vue&type=template&id=6bef4970&scoped=true&"
import script from "./affiliate-self-assessment.view.vue?vue&type=script&lang=ts&"
export * from "./affiliate-self-assessment.view.vue?vue&type=script&lang=ts&"
import style0 from "./affiliate-self-assessment.view.vue?vue&type=style&index=0&id=6bef4970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bef4970",
  null
  
)

export default component.exports